import {
  focusNextItem,
  focusPreviousItem
} from './utils'

/**
 * Enable the roving tabindex and set the control keys
 * @param {Node} parent The element node
 * @param {String} nextKey The event.key name to select next item
 * @param {String} prevKey The event.key name to select previous item
 * @param {String} element The type of child elements to be selectable
 */
export default function rovingTabindex (parent, nextKey, prevKey, element) {
  /**
   * Auto set the tabindex order to prepare
   * the roving tabindex
   */
  Array.from(parent.children).forEach((item, index) => {
    item.setAttribute('tabindex', index === 0 ? '0' : '-1')
  })

  /**
   * Activate the roving tabindex navigation
   */
  parent.addEventListener('keydown', (event) => {
    switch (event.key) {
      case nextKey:
        event.preventDefault()
        focusNextItem(parent, element)
        break
      case prevKey:
        event.preventDefault()
        focusPreviousItem(parent, element)
        break
      default:
        break
    }
  }, true)
}
